import Service from "../../Service";

const resource = "HmnMassiveAssistanceGang/";

export default {

    save(list, requestID) {
        return Service.post(resource + "save", list, {
            params: { requestID: requestID },
        });
    },
    

    pagination(dtr, requestID) {
        return Service.post(resource + "pagination", dtr, {
            params: { requestID: requestID },
        });
    },

    list(parameters, requestID) {
        return Service.post(resource + "list", parameters, {
            params: { requestID: requestID },
        });
    },

};